import {UIGameTimerController} from '../../../shared/scripts/ui_game/UIGameTimerController'
import {SectionBgView} from '../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {TextView} from '../../../shared/scripts/ui_canvas_engine/TextView'
import {GameFont} from '../../../shared/scripts/GameFont'
import {TranslationObject} from '@colonist/i18n'
import {turnSecondsInToTimerFormat} from '../../../shared/scripts/ui_utils/ClientUtils'

export class UIWGameTimerController extends UIGameTimerController {
    protected container: SectionBgView
    protected isHiddenPermanently: boolean = false

    private createContainer(): SectionBgView {
        const canvas = this.uiGameManager.canvasController
        const x = canvas.appW - canvas.chatWidth - canvas.itemSize
        const y = canvas.appH - canvas.itemSize * 1.5
        const w = canvas.itemSize
        const h = canvas.itemSize / 2
        const container = new SectionBgView(x, y, w, h, canvas.app.stage)
        container.drawRoundedBg()
        return container
    }

    createText(): TextView {
        if(this.container !== undefined) this.container.destroy()
        this.container = this.createContainer()
        if(this.isHiddenPermanently) this.container.visible = false

        const text: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: turnSecondsInToTimerFormat(this.secondsLeft)}}
        const textView = new TextView(text, 0, 0, this.container.width, this.container.height, this.container, GameFont.Size.L)
        textView.centerX()
        return textView
    }

    protected onBeginnerModeStart(): void {
        this.container.visible = false
        this.isHiddenPermanently = true
    }
}
